import React, { Component } from "react";
import { Container, Row, Col, CardImg } from "reactstrap";

import FAQ from "../../../FAQ/faq";
import faqs from "./qa";
import "./style.css";

import CourseHero from "../../CourseComponents/Hero/courseHero";
import BackgroundImage from "../../../images/dig-hero2-v2.png";
import HowToApply from "../../CourseComponents/How-To-Apply/how-to-apply";
import CourseOverview from "../../CourseComponents/CourseOverview/courseOverview";
import WeekOverview from "../../CourseComponents/WeekOverview/weekOverview";
import WeekCard from "../../CourseComponents/WeekCards/weekCard";
import CareerSupport from "../../CourseComponents/CareerSupport/careerSupport";
import ProgramDates from "../../CourseComponents/ProgramDates/programDates";
import ProgramCard from "../../CourseComponents/ProgramCard/programCard";
import FinanceOptions from "../../CourseComponents/FinanceOptions/financeOptions";
import { Helmet } from "react-helmet";

export default class DigMkInten extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseName: "Digital Marketing",
      courseType: "Intensive",
      courseHours: "Part-Time",
      overview: {
        time: "Part-Time",
        weeks: "26 Weeks",
        hours: "200 Hours",
        teaser: "Add Digital Marketing To Your Skill Set",
        overview: `The Digital Marketing Intensive prepares students to become
                   familiar with the most critical tools used by professional marketers, 
                   in addition to those used by professionals looking to build their businesses. 
                   You’ll learn data and analytics from Google SEO, Adwords to Linkedin APIs and Instragram posts.
                    Prospective students enrolled in this course are either professionals in marketing or aspiring to become part of the marketing industry.`
      },
      weeksubtext: `Dive into the world of Digital Marketing and learn the tools important in the digital marketing world. Each lesson is covered over a 4 week period and covers from framework to marketing analytics.`,
      card1: {
        title: "Week 1",
        subtitle: "Digital Marketing & Frameworks",
        topics: [
          "RACE Planning & Framework",
          "Marketplace & Analysis",
          "Objective & Strategy"
        ]
      },
      card2: {
        title: "Week 2",
        subtitle: "Channels, Paid Social Media",
        topics: ["Analytics, Influencers", "Tools & Driving Traffic"]
      },
      card3: {
        title: "Week 3",
        subtitle: "Content Optimization & Customer Acquisition",
        topics: ["SEO & Copywriting", "Targeted Content"]
      },
      card4: {
        title: "Week 4",
        subtitle: "Marketing Analytics & Budgetary Planning",
        topics: ["Marketing KPIs", "Vanity Metrics", "Budgets"]
      }
    };
  }
  render() {
    return (
      <div className="overflow">
           <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <CourseHero
          courseName={this.state.courseName}
          courseType={this.state.courseType}
          courseHours={this.state.courseHours}
          cName="digmk-jumbo"
          source='Digital_marketing_v1'
        />

        <div className="all-pages">
          <CourseOverview
            time={this.state.overview.time}
            weeks={this.state.overview.weeks}
            hours={this.state.overview.hours}
            overview={this.state.overview.overview}
            teaser={this.state.overview.teaser}
          >
            <CardImg
              className="rounded-0"
              top
              height="auto"
              src="img/digital-marketing-icon-v2.png"
              alt="Card image cap"
            />
          </CourseOverview>

          <section>
            <Container>
              <Row>
                <Col
                  xs={{ size: 12 }}
                  lg={{ size: 11, offset: 1 }}
                  className="left-align ditl-headline "
                >
                  <h1 className=""> Designed to Balance Busy Work Schedules</h1>
                </Col>
              </Row>

              <Row className="">
                <Col lg={{ size: 5, offset: 1 }}>
                <Row className=" left-align pt-5">
                      <Col xs={{ size: 11 }} lg={{ size: 11 }}>
                        <p>
                          Scheduled for two evening week days plus
                          a Saturday morning, our intensive course is perfect
                          for students who are looking for something to fit into
                          their current work schedule.{" "}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className="ditl-list left-align pl-0 pr-0  text-lg-left"
                        xs={{ size: 5 }}
                      >
                        <h3 className="pl-3 yellow">Evenings</h3>
                        {" "}
                        <ul className="py-0">
                          <li>Standups</li>
                          <li>Lectures and Labs</li>
                          <li>Coding / SEO</li>
                      
                        </ul>{" "}
                      </Col>
                      <Col
                        className="ditl-list left-align ml-4  text-lg-left"
                        xs={{ size: 5 }}
                      >
                       <h3 className="yellow pl-0 text-left text-lg-left">Weekends</h3>
                        <ul className="py-0 pl-0">
                        
                          <li>Meetups</li>
                          <li>Marketing Analysis</li>
                          <li>Career Coaching</li>
                        </ul>
                      </Col>
                    </Row>
                </Col>
                <Col className="d-none d-lg-block" md={{ size: 5 }}>
                  <CardImg
                    className="clear-card"
                    top
                    width="100%"
                    src="img/exp-collage-v2.png"
                    alt="Card image cap"
                  />
                </Col>
              </Row>


            </Container>
          </section>

          <WeekOverview subtext={this.state.weeksubtext}>
            <Row className="justify-content-center">
              <WeekCard
                sm="6"
                md="6"
                lg="2"
                title={this.state.card1.title}
                subtitle={this.state.card1.subtitle}
                topics={this.state.card1.topics}
              />
              <WeekCard
                sm="6"
                md="6"
                lg="2"
                title={this.state.card2.title}
                subtitle={this.state.card2.subtitle}
                topics={this.state.card2.topics}
              />
              <WeekCard
                sm="6"
                md="6"
                lg="2"
                title={this.state.card3.title}
                subtitle={this.state.card3.subtitle}
                topics={this.state.card3.topics}
              />
              <WeekCard
                sm="6"
                md="6"
                lg="2"
                title={this.state.card4.title}
                subtitle={this.state.card4.subtitle}
                topics={this.state.card4.topics}
              />
            </Row>
          </WeekOverview>
          <CareerSupport>
            <CardImg
              className="career-support-img"
              top
              height="100%"
              width="100%"
              src="img/dig-career-v2.png"
              alt="Card image cap"
            />
          </CareerSupport>

          <HowToApply />
          <ProgramDates>
            <ProgramCard
              days="Nov 17 - Dec 23, 2019"
              time="Mon to Fri: 9:00AM - 5:00PM"
              exclude="Excluding: 11/28, 11/29"
            />
          </ProgramDates>

          <FinanceOptions tuition="$3,550" />

          <FAQ faqs={faqs} />
        </div>
      </div>
    );
  }
}
